// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdvanceNumberController from "./advance_number_controller"
application.register("advance-number", AdvanceNumberController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import DocumentExpirationController from "./document_expiration_controller"
application.register("document-expiration", DocumentExpirationController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import FormattedNumberInputController from "./formatted_number_input_controller"
application.register("formatted-number-input", FormattedNumberInputController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PaymentAllocationFormController from "./payment_allocation_form_controller"
application.register("payment-allocation-form", PaymentAllocationFormController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import PayoffReviewController from "./payoff_review_controller"
application.register("payoff-review", PayoffReviewController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import NotificationReadController from "./notification_read_controller"
application.register("notification-read", NotificationReadController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
